module.exports = __webpack_public_path__ + "img/backup.0bb90cc.svg";